import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../../lib/moment.js'
import { Input } from 'reactstrap'
import SearchIcon from "../../../static/images/search_icon.svg"
import { DateHeader } from '../helpers/header'
import metrolendarHelper from '../../timesheet/helpers/date'

export const TimesheetStatus = class extends React.Component {
  state={ tempSearch: '' }

  render() {
    const { handleSearch } = this.props
    const month = get(this.props, 'timesheetRequest.timesheetRequest.timesheet_snapshot.month')
    const dates = metrolendarHelper.getTableDates(moment(month), 'month')

    return (
      <Wrapper id='searchBarTimesheetStatus'>
        <SearchField
          placeholder='Search by project'
          onChange={ (e) => {
            if (e.target.value === '') handleSearch('')
            this.setState({ tempSearch: e.target.value })
          } }
          onKeyDown={ (e) => {
            if (e.keyCode === 13) handleSearch(this.state.tempSearch)
          } }
        />
        <DateHeader dates={ dates } />
      </Wrapper>
    )
  }
}

TimesheetStatus.propTypes = {
  handleSearch: PropTypes.func,
}
TimesheetStatus.defaultProps = {
  handleSearch: () => {},
}

const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  margin-bottom: 5px;
  height: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const SearchField = styled(Input)`
  height: 30px;
  width: 30%;
  padding-left: 30px
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: 'Gotham' !important;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 1% !important;
  margin-right: 1% !important;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`




// WEBPACK FOOTER //
// ./src/components/timesheet/search-bar/timesheet-status.js